import { SvgIcon, SvgIconProps } from '@mui/material';


/* eslint-disable-next-line */
export interface CcfFacebookCommentIconProps extends SvgIconProps { }

/**
 * Component to display facebook icon
 * @param props -CcfFacebookCommentIconProps
 * @returns svg icon of facebook
 * @example <CcfFacebookCommentIcon/>
 */
export function CcfFacebookCommentIcon(props: CcfFacebookCommentIconProps) {
  return (
    <SvgIcon {...props}>
      <g transform="scale(0.8) translate(8 9)">
        <path fill="#1C1C1C" d="M30 0H2a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h2v7l8-7h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm1 22a2 2 0 0 1-2 2H12l-1.167 1L5 30v-6H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v19z"></path>
        </g>
    </SvgIcon>
    );
}

export default CcfFacebookCommentIcon;
